import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2025 Dhrey Advisors. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;

